import React from 'react';
import loadable from '@loadable/component';
import { Redirect, Switch, Route } from 'react-router-dom';

const errorLoading = err => console.log('Embeds failed to load!', err);

const EmbeddedLineChart = loadable(() =>
  import(/* webpackChunkName: "embedded-line" */ '@routes/embeds/LineChart/components').catch(errorLoading),
);

const EmbeddedMap = loadable(() =>
  import(/* webpackChunkName: "embedded-map" */ '@routes/embeds/Map/components').catch(errorLoading),
);

export default () => {
  return (
    <Switch>
      <Route exact path="/embed/line" component={EmbeddedLineChart} />
      <Route exact path="/embed/map" component={EmbeddedMap} />
      <Redirect to="/" />
    </Switch>
  );
};
